import axios from "axios"
import { useGeneral } from "../context/general"

export default function useUserSettings() {
    const { setPopupAlert } = useGeneral()

    const updateUserPassword = (currPassword, newPassword) => {
        // fetch('/api/userSettings/changeUserPassword', {
        //     method: 'post',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({ currPassword, newPassword })
        // })
        axios({
            method: 'post',
            url: '/api/userSettings/updateUserPassword',
            data: { currPassword, newPassword },
        })
        .then(res => {
            if (res.status === 200) {
                setPopupAlert('success', 'Password updated!')
            } else {
                setPopupAlert('error', 'Current password does not match.')
            }
        }).catch(e => {
            setPopupAlert('error', "Something went worng, password wasn't updated.")
        })
    }

    return {
        updateUserPassword
    }
}